import React, { SVGProps } from 'react';

const Graph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={28}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color="var(--secondaryBackground)"
    {...props}
    data-palette="Graph">
    <path
      d="M3.5 14h4.667l3.5 9.333 4.666-18.666 3.5 9.333H24.5"
      stroke="var(--dropdownIconColor)"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Graph;
